<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Refferal Partner</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Refferal Partner</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group label="Partner Type">
            <b-form-radio-group
              id="radio-group-1"
              v-model="selected"
              @change="clearPartner()"
              :options="partner_type"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
          <b-row>
            <b-col>
              <vue-multiselect
                v-show="selected == 'retail'"
                v-model="retail"
                id="ajax"
                open-direction="bottom"
                :preserve-search="true"
                :options="dataRetail"
                v-validate="selected == 'retail'?'required':''"
                name="retail"
                data-vv-as="Retail Partner"
                :custom-label="nameWithLang"
                placeholder="Type to chose Retail Partner"
                label="name"
                track-by="code"
                :loading="isLoadingRetail"
                :searchable="true"
                @search-change="asyncFindRetail"
              ></vue-multiselect>

              <vue-multiselect
                v-show="selected == 'corporate'"
                id="ajax2"
                open-direction="bottom"
                v-model="corporate"
                v-validate="selected == 'corporate'?'required':''"
                name="corporate"
                data-vv-as="Corporate Partner"
                :preserve-search="true"
                :options="dataCorporate"
                :custom-label="nameWithLang"
                placeholder="Type to chose Corporate Partner"
                label="name"
                track-by="code"
                :loading="isLoadingCorporate"
                :searchable="true"
                @search-change="asyncFindCorporate"
              ></vue-multiselect>
              <p
                v-show="selected == 'retail'"
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('retail') }}</p>
              <p
                v-show="selected == 'corporate'"
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('corporate') }}</p>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Corporate Partner"
            label-for="input-1"
          >
            <select
              class="custom-select"
              v-validate="'required'"
              name="corporate-partner"
              v-model="code"
              required
            >
              <option value>Select Corporate Partner</option>
              <option
                v-for="option in options"
                :key="option"
                :value="option.coorporate_code"
              >{{option.company_name}}</option>
            </select>
            <b-form-invalid-feedback
              id="input-corporate-partner-feedback"
            >{{ veeErrors.first('corporate-partner') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>-->
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Referral Code"
            label-for="input-1"
          >
            <input
              v-model="referral_code"
              v-validate="'required|alpha_num'"
              name="referral_code"
              data-vv-as="Referral Code"
              type="text"
              class="form-control"
              placeholder="Referral Code"
            />
            <b-form-invalid-feedback
              id="input-referral_code-feedback"
            >{{ veeErrors.first('referral_code') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Value (Rupiah)"
            label-for="input-1"
          >
            <input
              v-model="value"
              v-validate="'required|numeric'"
              name="value"
              data-vv-as="Value"
              type="number"
              class="form-control"
              placeholder="Rp"
            />
            <b-form-invalid-feedback id="input-value-feedback">{{ veeErrors.first('value') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Start Date"
                    v-model="period_start"
                    :format="customFormatter"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col class="pt-1 px-4 form-control del-calender-select border-left-0" md="2">
                    <b-row class="pt-1">
                      <b-col>
                        <b-link @click="resetStardate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mt-n2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="End Date"
                  v-model="period_end"
                  :format="customFormatter"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col
                  align="left"
                  class="pt-1 px-4 form-control del-calender-select border-left-0"
                  md="2"
                >
                  <b-row align="left" class="pt-1">
                    <b-col>
                      <b-link @click="resetEnddate" style="text-decoration:none">
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="post()" class="mr-3" size="lg">
            Create
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'refferalPartner'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { throttle } from 'lodash';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      isLoadingCorporate: false,
      isLoadingRetail: false,
      searchTermCorporate: '',
      searchTermRetail: '',
      dataCorporate: [],
      dataRetail: [],
      code: '',
      value: '',
      cek: 'GAGAL',
      corporate: '',
      retail: '',
      isCorporate: false,
      isRetail: false,
      period_start: '',
      period_end: '',
      referral_code: null,
      selected: 'retail',
      is_present: false,
      options: [],
      partner_type: [
        { text: 'Retail', value: 'retail' },
        { text: 'Corporate', value: 'corporate' },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },

  beforeCreate() {
    this.$store.dispatch(
      'RefferalPartnerModule/getCorporatePartners',
      this.$route.params.id,
    );
  },
  created() {
    this.$store.watch(
      state => state.RefferalPartnerModule.corporatepartner,
      (newValue, oldValue) => {
        this.options = newValue;
      },
    );
  },
  watch: {
    // corporate: _.debounce(function() {
    //   this.isCorporate = false;
    // }, 1000),
    // retail: _.debounce(function() {
    //   this.isRetail = false;
    // }, 1000),
    // isRetail: function(value) {
    //   if (!value) {
    //     this.HitRetail(this.retail);
    //   }
    // }
    // isCorporate: function(value) {
    //   if (!value) {
    //     this.HitCorporate(this.corporate);
    //   }
    // }
  },
  methods: {
    asyncFindRetail(query) {
      this.isLoadingRetail = true;
      this.searchTermRetail = query;
      this.getWorksAsync();
    },
    asyncFindCorporate(query) {
      this.isLoadingCorporate = true;
      this.searchTermCorporate = query;
      this.getWorksAsync();
    },
    clearPartner() {
      this.dataCorporate = [];
      this.dataRetail = [];
      this.corporate = '';
      this.retail = '';
    },
    getWorksAsync: throttle(function () {
      const retail = this.searchTermRetail.toLowerCase();
      const corporate = this.searchTermCorporate.toLowerCase();
      const formData = new FormData();
      formData.append('partner_type', this.selected);
      formData.append(
        'search_param',
        this.selected == 'retail' ? retail : corporate,
      );
      formData.append('limit', 10);
      this.$store
        .dispatch('RefferalPartnerModule/getPartners', formData)
        .then((response) => {
          this.isLoadingRetail = false;
          this.isLoadingCorporate = false;
          this.dataRetail = this.selected == 'retail' ? response.data.data : '';
          this.dataCorporate = this.selected == 'corporate' ? response.data.data : '';
        })
        .catch((error) => {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.isLoadingRetail = false;
          this.isLoadingCorporate = false;
        });
    }, 500),
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    resetStardate() {
      this.start_date = null;
    },
    resetEnddate() {
      this.end_date = null;
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          if (this.period_start != '' && this.period_end == '') {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append('period_start', start);
            formData.append('period_end', this.period_end);
          }
          if (this.period_end != '' && this.period_start == '') {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append('period_start', this.period_start);
            formData.append('period_end', end);
          }
          if (this.period_start != '' && this.period_end != '') {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append('period_start', start);
            formData.append('period_end', end);
          }
          if (this.period_start == '' && this.period_end == '') {
            formData.append('period_start', this.period_start);
            formData.append('period_end', this.period_end);
          }
          formData.append('referral_code', this.referral_code);
          formData.append('value', this.value);
          if (this.selected == 'retail') {
            formData.append('referral_partner_id', this.retail.id);
            formData.append('referral_partner_name', this.retail.name);
          }
          if (this.selected == 'corporate') {
            formData.append('referral_partner_id', this.corporate.id);
            formData.append('referral_partner_name', this.corporate.name);
          }
          formData.append('partner_type', this.selected);
          this.$store
            .dispatch('RefferalPartnerModule/postRefferalPartner', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'refferalPartner' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
  },
};
</script>

<style>
</style>
